module.exports = __webpack_public_path__ + "assets/83af83b6969e0ec8672b73ca2e7a7ca0.mp3";